// export default function division(equation) {
//   // 数据 将()中的数据 替换为字符集
//   let numMap = dataConverSymbol(equation);
//   // console.log(equation)
//   // console.log(numMap)
//   let o, t, d, r = '0', arr, obj, leng, newArr = []
//   // 存在余数时
//   if(equation.num4.indexOf('...') > -1) {
//     let dArr = equation.num4.split('...')
//     d = dArr[0]
//     r = dArr[1]
//   } else {
//     d = equation.num4
//   }

//   o = equation.num1
//   t = equation.num2
//   arr = [ d.split('') ]
//   obj = {
//     d: d.split(''),
//     o: o.split(''),
//   }
//   leng = Math.max((d).length, (o).length)
//   // console.log(leng)

//   let removeCoefficient = 0 // 移除系数
//   let converT = symbolConvertData(t, numMap)
//   while(obj.d.length > 0) {

//     // arr.push([...obj.o])
//     // 记录未处理之前的obj.o
//     let recordOldO = [...obj.o]

//     obj.o = obj.o.map(its => symbolConvertData(its, numMap))
//     let n = 0
//     o:
//     for(let i = 0; i < obj.o.length; i++) {
//       n += obj.o[i]
//       let res = n * 1 - (symbolConvertData(obj.d[0], numMap) * converT),
//       subtrahendLeng = String(symbolConvertData(obj.d[0], numMap) * converT).split('').length

//       if(isNaN(res) || res < 0) continue o;
//       else if(res > 0) {
//         obj.o.splice(0, i + 1)
//         obj.o.unshift(...String(res).split(''))
        
//         removeCoefficient += i + 1
//         arr.push({
//           [Math.max(removeCoefficient - subtrahendLeng, 0)]: String(symbolConvertData(obj.d[0], numMap) * converT).split('')
//         })
//         removeCoefficient -= String(res).split('').length
//       } else if(res == 0) {
//         obj.o.splice(0, i + 1)
//         removeCoefficient += i + 1
//         arr.push({
//           [Math.max(removeCoefficient - subtrahendLeng, 0)]: String(symbolConvertData(obj.d[0], numMap) * converT).split('')
//         })
//       }
//       break o;
//     }
    
//     if(arr.length > 3) {
//       let arrNextEle = Object.values(arr[arr.length - 1]).flat().join('') * 1
//       , acc = ''

//       r:
//       for(let r = 0; r < recordOldO.length; r++) {
//         acc += String(recordOldO[r])
        
//         if(arrNextEle <= Number(acc)) {
//           break r;
//         } 
//       }

//       arr.splice(arr.length - 1, 0, {
//         [Math.max(removeCoefficient - 1, 0)]: acc.split('')
//       })
//     } else {
//       arr.splice(arr.length - 1, 0, {
//         [Math.max(removeCoefficient - 1, 0)]: [...recordOldO]
//       })
//     }

//     obj.d = obj.d.splice(1)
//   }
//   // 防止r 是多位数字 拆分成个位组成数组
//   obj.o.length > 0 && arr.push(r ? String(r).split(''): [...obj.o])
//   // obj.o.length == 0 && arr.push([r])
//   // console.log(arr)
  
//   for(let i = 0; i < arr.length; i++) {
//     let prev = null, next = null
//     if(Array.isArray(arr[i])) {
//       prev = new Array(leng - arr[i].length).fill('#')
//       newArr[i] = [...prev, ...arr[i]]
//     } else {
//       let [index] = Object.keys(arr[i])
//       prev = new Array(Number(index)).fill('#')
      
//       next = new Array(leng - arr[i][index].length - index).fill('#')
//       newArr[i] = [...prev, ...arr[i][index], ...next]
//     }
//   }

//   let fill = {
//     divisor: (t).split(''),
//     list: newArr,
//     numMap
//   }

//   // console.log(fill)
//   return fill
// }

// /**
//  * 处理数据 将()中的数据 替换为字符集
//  * @param {*} equation 
//  * @returns 
//  */
// function dataConverSymbol(equation) {
//   let regex = /\(\d+?\)/g, numMap = {
//     0: {}, 1: {}, 2: {}
//   }, letter = new Array(62).fill().map((its, idx) => its = String.fromCharCode(65 + idx))

//   let regex1 = equation.num1.match(regex)
//   let regex2 = equation.num2.match(regex)
//   let regex3 = equation.num4.match(regex)
 
//   for(let i = 0; regex1 && i < regex1.length; i++) {
//     let leter = letter.splice(0, 1)
//     numMap[0][leter] = regex1[i].substring(1, regex1[i].length - 1)
//     equation.num1 = equation.num1.replace(regex1[i], leter)
//   }

//   for(let i = 0; regex2 && i < regex2.length; i++) {
//     let leter = letter.splice(0, 1)
//     numMap[1][leter] = regex2[i].substring(1, regex2[i].length - 1)
//     equation.num2 = equation.num2.replace(regex2[i], leter)
//   }

//   for(let i = 0; regex3 && i < regex3.length; i++) {
//     let leter = letter.splice(0, 1)
//     numMap[2][leter] = regex3[i].substring(1, regex3[i].length - 1)
//     equation.num4 = equation.num4.replace(regex3[i], leter)
//   }

//   return numMap
// }

// function symbolConvertData(symbol, numMap) {
//   if(symbol.length > 1) {
//     let data = '', letter = new Array(62).fill().map((its, idx) => its = String.fromCharCode(65 + idx))
//     for(let i = 0; i < symbol.length; i++) {
//       if(!letter.includes(symbol[i])) data += symbol[i]
//       else {
//         data += symbolConvertData(symbol[i], numMap)
//       }
//     }
    
//     return data
//   } else {
//     for(let i in numMap) {
//       let obj = numMap[i]
//       for(let j in obj) {
//         if(symbol == j) {
//           return obj[j]
//         }
//       }
//     }

//     return symbol
//   }
// }

export default function division(equation) {
  // console.clear()
  console.log(JSON.parse(JSON.stringify(equation)))
  // 数据 将()中的数据 替换为字符集
  let backups = getEqualityData(equation)
  let numMap = dataConverSymbol(equation);

  let o, t, d, leng, arr
  // 存在余数时
  if(backups.num4.indexOf('...') > -1) {
    let dArr = backups.num4.split('...')
    d = dArr[0]
  } else {
    d = backups.num4
  }

  o = backups.num1.split('')
  t = equation.num2
  leng = Math.max((d).length, (o).length)
  arr = [ autoFill(leng, d, leng - d.length, 0), o ]

  // 记录除法算式的步骤
  let dividend = backups.num2
  , recordOldO
  console.log(dividend)
  for(let i = 0; i < leng; i++) {
    console.log(' ------------- continue -----------')

    if(arr[0][i] == '#') continue

    let val = dividend * arr[0][i] + ''
    console.log(dividend, arr[0][i])

    let list = autoFill(leng, val, (i + 1) - val.length)
    recordOldO = recordOldO || arr[arr.length - 1]
    console.log('recordOldO', recordOldO)

    if(val != 0) arr.push(list)
    // 如果val == 0 && i是最后一位索引 直接跳出循环
    else if(i == (leng - 1)) {
      continue
    }

    console.log(val)
    console.log(list)
    let arrNextEle = list.filter(num => Number(num) == num && num).join('')
    , acc = ''
    , diff
    r:
    for(let r = 0; r < recordOldO.length; r++) {
      acc += String(recordOldO[r])
      console.log(acc, arrNextEle)
      if(arrNextEle <= Number(acc)) {
        diff = acc - arrNextEle
        console.log(diff)
        recordOldO = [...String(diff).split(''), ...(recordOldO.slice(r + 1))]
        recordOldO = new Array(leng - recordOldO.length).fill('0').concat(recordOldO)
        break r;
      } 
    }
    val = recordOldO.slice(0, i + 2).join('') * 1 + ''
    if(Number(val) < Number(dividend)) continue
    list = autoFill(leng, val, (i + 2) - val.length) 
    console.log(list, val)
    console.log(val, dividend)
    if(val != 0) arr.push(list)
  }

  // 将带有字母的数据替换进arr中
  let [cha, yushu] = equation.num4.split('...')
  arr[0] = autoFill(leng, cha, leng - cha.length)
  arr[1] = equation.num1.split('')
  // console.log(yushu)
  if(yushu) {
    if(arr.length % 2 == 1) arr.push(autoFill(leng, yushu, leng - yushu.length))
    else arr[arr.length - 1] = autoFill(leng, yushu, leng - yushu.length)
    // arr[arr.length - 1] = autoFill(leng, yushu, leng - yushu.length)
  } else {
    // arr.splice(arr.length - 1, 1)
  }

  let fill = {
    divisor: (t).split(''),
    list: arr,
    numMap
  }
  console.log(fill)
  return fill
}

/**
 * 处理数据 将()中的数据 替换为字符集
 * @param {*} equation 
 * @returns 
 */
function dataConverSymbol(equation) {
  let regex = /\(\d+?\)/g, numMap = {
    0: {}, 1: {}, 2: {}
  }, letter = new Array(62).fill().map((its, idx) => its = String.fromCharCode(65 + idx))

  let regex1 = equation.num1.match(regex)
  let regex2 = equation.num2.match(regex)
  let regex3 = equation.num4.match(regex)

  for(let i = 0; regex3 && i < regex3.length; i++) {
    let leter = letter.splice(0, 1)
    numMap[2][leter] = regex3[i].substring(1, regex3[i].length - 1)
    equation.num4 = equation.num4.replace(regex3[i], leter)
  }
 
  for(let i = 0; regex1 && i < regex1.length; i++) {
    let leter = letter.splice(0, 1)
    numMap[0][leter] = regex1[i].substring(1, regex1[i].length - 1)
    equation.num1 = equation.num1.replace(regex1[i], leter)
  }

  for(let i = 0; regex2 && i < regex2.length; i++) {
    let leter = letter.splice(0, 1)
    numMap[1][leter] = regex2[i].substring(1, regex2[i].length - 1)
    equation.num2 = equation.num2.replace(regex2[i], leter)
  }

  return numMap
}

// 获取等式的真实数据
function getEqualityData(equation) {
  let regex = /\d+/g;
  equation = JSON.parse(JSON.stringify(equation))
  for(let key in equation) {
    if(key == 'num4') {
      let [ val ] = equation[key].split('...')
      // console.log(val)
      equation[key] = val.match(regex).join('')
    }
    else if(key != 'sumType') equation[key] = (equation[key].match(regex) || []).join('')
  }
  console.log(equation)
  return equation
}

/**
 * 填充数据
 * @param {*} leng 数据总长度
 * @param {*} val 填充的数据
 * @param {*} i 填充的索引
 * @returns 
 */
function autoFill(leng, val, i) {
  // console.log(leng, val, i)
  i = Math.min(i, leng - 1)
  let l = []
  , lLeng
  for(let j = 0; j < i; j++) {
    l.push('#')
  }
  l.push(...val.split(''))
  lLeng = l.length
  for(let k = 0; k < (leng - lLeng); k++) {
    l.push('#')
  }

  if(l.length > leng) {
    l.splice(0, 1)
  }
  return l
}